import { regPath } from 'shared-base';

export const parsePath = () => {
  const output: Json = {};
  const parts = regPath(window.location.pathname);

  if (parts.length < 4 || parts[1] !== 'editor') {
    return output;
  }

  output.projectId = parts[2];
  output.modelId = parts[3];

  return output;
};
